import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import NextLink from 'next/link';
import {
  spacing,
  fontWeight,
  fontSize,
  mediaMax,
} from 'presentations/views/styles';
import { black, gray04, gray02 } from 'presentations/views/styles/color';
import ResourceCategoryList from 'presentations/views/components/molecules/ResourceCategoryList';
import ResourceTagList from 'presentations/views/components/molecules/ResourceTagList';
import Image from 'presentations/views/components/atoms/Image';
import { ResourceListItem } from 'presentations/api/schema/resources';
import { resourcePath } from 'presentations/routes/path';
import { formatToDate } from 'infras/datetime';
import { transformCmsImageUrl } from 'presentations/assets';

export interface Props {
  item: ResourceListItem;
  isThumbnailSizeNormal?: boolean;
}

export default function Component(props: Props) {
  let thumbnailWidth;
  let thumbnailHeight;
  if (props.isThumbnailSizeNormal) {
    thumbnailWidth = 240;
    thumbnailHeight = 160;
  } else {
    thumbnailWidth = 200;
    thumbnailHeight = 133;
  }

  const link = resourcePath(props.item.categories[0].slug, props.item.slug);

  return (
    <Container>
      <NextLink href={link} passHref>
        <ThumbnailImageContainer
          isThumbnailSizeNormal={props.isThumbnailSizeNormal || false}
        >
          {props.item.thumbnailUrl && (
            <Image
              src={
                transformCmsImageUrl(props.item.thumbnailUrl, { width: 200 }) ||
                ''
              }
              alt={props.item.title}
              width={100}
              height={67}
            />
          )}
        </ThumbnailImageContainer>
      </NextLink>
      <InfoContainer>
        <NextLink href={link} passHref>
          <Title>{props.item.title}</Title>
        </NextLink>
      </InfoContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  color: ${black};
`;

const ThumbnailImageContainer = styled.a<{ isThumbnailSizeNormal: boolean }>``;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing(16)};

  line-height: 160%;
  letter-spacing: 0.05em;

  ${mediaMax.tablet} {
    margin-left: ${spacing(16)};
  }
`;

const Title = styled.a`
  font-size: ${fontSize(13)};
  color: ${black};
  overflow-wrap: break-word;
  word-break: break-word;
`;

const CreatedAt = styled.div`
  margin-bottom: ${spacing(12)};

  font-size: ${fontSize(12)};
  color: ${gray02};

  ${mediaMax.tablet} {
    margin-bottom: 0;
    font-size: ${fontSize(10)};
  }
`;

const TagListContainer = styled.div`
  margin-bottom: ${spacing(8)};

  ${mediaMax.tablet} {
    display: none;
  }
`;
